const shortkeys = {
  SHORTKEY_NUDGE_LEFT: "left",
  SHORTKEY_NUDGE_UP: "up",
  SHORTKEY_NUDGE_RIGHT: "right",
  SHORTKEY_NUDGE_DOWN: "down",
  SHORTKEY_NUDGE_LEFT_MORE: "shift+left",
  SHORTKEY_NUDGE_UP_MORE: "shift+up",
  SHORTKEY_NUDGE_RIGHT_MORE: "shift+right",
  SHORTKEY_NUDGE_DOWN_MORE: "shift+down",
  SHORTKEY_SEND_BACKWARD: "[",
  SHORTKEY_BRING_FORWARD: "]",
  SHORTKEY_SEND_TO_BACK: "shift+[",
  SHORTKEY_BRING_TO_FRONT: "shift+]",
  SHORTKEY_TOGGLE_GRID: "g",
  SHORTKEY_TOGGLE_EYEDROP: "i",
  SHORTKEY_TOGGLE_LOCK: "l",
  SHORTKEY_TOGGLE_HIDE: "h",
  SHORTKEY_TOGGLE_CHEATSHEET: "?",
  SHORTKEY_ACTIVATE_RECT_TOOL: "r",
  SHORTKEY_ACTIVATE_ROUNDED_RECT_TOOL: "u",
  SHORTKEY_ACTIVATE_ELLIPSE_TOOL: "o",
  SHORTKEY_ACTIVATE_PEN_TOOL: "v",
  SHORTKEY_ACTIVATE_PENCIL_TOOL: "p",
  SHORTKEY_ACTIVATE_TEXT_TOOL: "t",
  SHORTKEY_INCREASE_FONT_SIZE: "alt+=",
  SHORTKEY_DECREASE_FONT_SIZE: "alt+-",
  SHORTKEY_INCREASE_FONT_SIZE_BY_10: "alt+shift+=",
  SHORTKEY_DECREASE_FONT_SIZE_BY_10: "alt+shift+-",
  SHORTKEY_INCREASE_CHARACTER_SPACING: "alt+ctrl+l",
  SHORTKEY_DECREASE_CHARACTER_SPACING: "alt+ctrl+t",
  SHORTKEY_ALIGN_TEXT_LEFT: "alt+ctrl+[",
  SHORTKEY_ALIGN_TEXT_RIGHT: "alt+ctrl+]",
  SHORTKEY_ALIGN_TEXT_CENTER: "alt+ctrl+\\",
  SHORTKEY_UNDO: "mod+z",
  SHORTKEY_REDO: "ctrl+shift+z",
  SHORTKEY_REDO_2: "mod+shift+z",
  SHORTKEY_SELECT_ALL: "mod+a",
  SHORTKEY_ZOOM_IN: "mod+=",
  SHORTKEY_ZOOM_OUT: "mod+-",
  SHORTKEY_ZOOM_FIT: "mod+0",
  SHORTKEY_EXPORT: "mod+s",
  SHORTKEY_MAKE_TEXT_BOLD: "mod+b",
  SHORTKEY_MAKE_TEXT_ITALIC: "mod+i",
  SHORTKEY_CENTER_CANVAS: "mod+1",
  SHORTKEY_ZOOM_TO_SELECTION: "mod+2",
  SHORTKEY_CMD_GROUP: "mod+g",
  SHORTKEY_CMD_UNGROUP: "mod+u",
  SHORTKEY_CMD_EXPAND: "mod+shift+g",
  SHORTKEY_PASTE_IN_PLACE: "mod+shift+v",
  SHORTKEY_CLONE: "mod+d",

  SHORTKEY_DELETE: "Delete",
  SHORTKEY_BACKSPACE: "Backspace",
  SHORTKEY_CANCEL: "esc",
  SHORTKEY_ENTER: "enter",

  SHORTKEY_UNLOCKALL: "shift+l",
  SHORTKEY_UNHIDEALL: "shift+h",

  SHORTKEY_HELP: "shift+/",
  SHORTKEY_COPY: "mod+c",
  SHORTKEY_CUT: "mod+x",
  SHORTKEY_PASTE: "mod+v",

  SHORTKEY_FILL_COLOR: "c",
  SHORTKEY_NEW_FILE: "alt+n",
  SHORTKEY_PAGES: "alt+p",
  SHORTKEY_LAYERS: "alt+l",
  SHORTKEY_ELEMENTS: "alt+e",
  SHORTKEY_SHAPES: "alt+s",
  SHORTKEY_UPLOAD_IMAGE: "alt+u",
  SHORTKEY_MORE_FEATURES: "alt+f",
  SHORTKEY_MORE_SHAPES: "mod+1",
  SHORTKEY_COMMENTS: "alt+c",
  SHORTKEY_HOME: "alt+h",
  SHORTKEY_SPACE: "space",
};

export default shortkeys;
